module.exports = __webpack_public_path__ + "img/DownloadOnAppStore-Badge-Web.f251d8ee.svg";